import { useContext, useEffect } from 'react';
import { LocalImagesContext } from './local-images-context';

export const SetLocalImagesContext = (images: any) => {
   const context = useContext(LocalImagesContext);
   useEffect(() => {
      context.setLocalImagesContext(images);
   }, [context, images]);
};
